/*
 * StoreCRM(obake) お気に入り バリエーション選択ピッカーの「出る/出ない」問題の修正。
 *
 * 背景:
 *   data-variant-id と data-variant-selector を付けた .storecrm-favorite では、
 *   StoreCRM本体がハートクリック時に基準バリエーションを即登録してしまうことがある。
 *
 * 対策:
 *   複数バリエーション商品では初回クリックをテーマ側で受け止め、登録はプルダウン内の
 *   バリエーション選択クリック時だけ StoreCRM に渡す。
 */
(function () {
  var DROPDOWN = '.storecrm-variantselector-dropdown';
  var FAVORITE = '.storecrm-favorite';
  var FALLBACK_CLASS = 'storecrm-variantselector-dropdown--theme-fallback';
  var FAVORITE_OFFSET = 6;
  var renderTimer;
  var positionTimer;
  var favoriteResizeObserver;
  var observedFavoriteSizing = ('WeakSet' in window) ? new WeakSet() : null;

  function productIdOf(el) {
    if (!el) return '';
    var holder = (el.matches && el.matches('[data-product-id]'))
      ? el
      : (el.querySelector ? el.querySelector('[data-product-id]') : null);
    return holder ? holder.getAttribute('data-product-id') : '';
  }

  function closestElement(target) {
    var node = target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    return node && node.closest ? node : null;
  }

  function parseJson(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function favoriteConfig() {
    return (window.storecrm_config && window.storecrm_config.favorite) || {};
  }

  function variantsOf(fav) {
    var variants = parseJson(fav && fav.getAttribute('data-variants'), []);
    return Array.isArray(variants) ? variants : [];
  }

  function isMultiVariantFavorite(fav) {
    return variantsOf(fav).length > 1;
  }

  function consumeClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function isVariantFavorited(variantId) {
    var wishlist = parseJson(window.localStorage && window.localStorage.getItem('storecrm_wishlist'), {});
    var variants = Array.isArray(wishlist.variants) ? wishlist.variants : [];
    return variants.indexOf(String(variantId)) >= 0 || variants.indexOf(Number(variantId)) >= 0;
  }

  function removeDropdowns() {
    document.querySelectorAll(DROPDOWN).forEach(function (dropdown) {
      dropdown.remove();
    });
  }

  function isVisibleDropdown(dropdown) {
    if (!dropdown || !dropdown.isConnected) return false;
    var style = window.getComputedStyle ? window.getComputedStyle(dropdown) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) return false;
    if (!dropdown.querySelector('a, button, [data-variant-id]')) return false;
    var rect = dropdown.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function hasVisibleDropdown() {
    return Array.prototype.some.call(document.querySelectorAll(DROPDOWN), isVisibleDropdown);
  }

  function favoriteAnchor(fav, anchor) {
    if (anchor && anchor.isConnected) {
      var rect = anchor.getBoundingClientRect();
      if (rect.width > 0 || rect.height > 0) return anchor;
    }
    return (fav && fav.querySelector && fav.querySelector('button, a, .storecrm-wishlistbutton')) || fav;
  }

  function positionFavorite(fav) {
    var imageBox = fav && fav.closest ? fav.closest('.image') : null;
    var image = imageBox && imageBox.querySelector ? imageBox.querySelector('.image__first .rimage__image') : null;
    if (!imageBox || !image) return;

    var imageBoxRect = imageBox.getBoundingClientRect();
    var imageRect = image.getBoundingClientRect();
    if (imageBoxRect.width <= 0 || imageRect.width <= 0) return;

    var top = Math.max(FAVORITE_OFFSET, Math.round(imageRect.top - imageBoxRect.top + FAVORITE_OFFSET));
    var right = Math.max(FAVORITE_OFFSET, Math.round(imageBoxRect.right - imageRect.right + FAVORITE_OFFSET));
    fav.style.setProperty('--storecrm-favorite-top', top + 'px');
    fav.style.setProperty('--storecrm-favorite-right', right + 'px');
  }

  function positionFavorites() {
    document.querySelectorAll(FAVORITE).forEach(positionFavorite);
  }

  function schedulePositionFavorites(delay) {
    window.clearTimeout(positionTimer);
    positionTimer = window.setTimeout(function () {
      window.requestAnimationFrame ? window.requestAnimationFrame(positionFavorites) : positionFavorites();
    }, delay || 50);
  }

  function observeFavoriteSizing() {
    if (!('ResizeObserver' in window)) return;
    if (!favoriteResizeObserver) {
      favoriteResizeObserver = new ResizeObserver(function () {
        schedulePositionFavorites(0);
      });
    }
    document.querySelectorAll('.product-block .image, .collection-block .image, ' + FAVORITE).forEach(function (el) {
      if (observedFavoriteSizing && observedFavoriteSizing.has(el)) return;
      favoriteResizeObserver.observe(el);
      if (observedFavoriteSizing) observedFavoriteSizing.add(el);
    });
  }

  function positionDropdown(dropdown, anchor) {
    var rect = anchor.getBoundingClientRect();
    var width = 250;
    var left = rect.left + window.pageXOffset;
    if (left + width > window.innerWidth) {
      left = Math.max(0, window.innerWidth - width);
    }
    dropdown.style.top = (rect.bottom + window.pageYOffset) + 'px';
    dropdown.style.left = left + 'px';
  }

  function variantLabel(variant) {
    return variant && variant.title ? variant.title : 'バリエーションを選択';
  }

  function applyFavoriteState(option, variantId) {
    var isFavorited = isVariantFavorited(variantId);
    option.classList.toggle('is-favorited', isFavorited);
    option.setAttribute('aria-pressed', isFavorited ? 'true' : 'false');
  }

  function buildFallbackDropdown(fav, anchor) {
    var productId = fav.getAttribute('data-product-id');
    var variants = variantsOf(fav);
    if (!productId || !Array.isArray(variants) || variants.length === 0 || !window.storecrm) return;

    removeDropdowns();

    if (variants.length === 1) {
      var single = document.createElement('a');
      single.setAttribute('data-product-id', productId);
      single.setAttribute('data-variant-id', variants[0].id);
      single.setAttribute('data-variant-selector', '');
      window.storecrm.toggleWishlist(single, isVariantFavorited(variants[0].id), favoriteConfig().is_only_member, favoriteConfig().non_member_link || '');
      return;
    }

    var dropdown = document.createElement('div');
    dropdown.className = 'storecrm-variantselector-dropdown ' + FALLBACK_CLASS;
    dropdown.setAttribute('data-product-id', productId);
    positionDropdown(dropdown, favoriteAnchor(fav, anchor));

    variants.forEach(function (variant) {
      var option = document.createElement('a');
      option.href = 'javascript:;';
      option.setAttribute('data-product-id', productId);
      option.setAttribute('data-variant-id', variant.id);
      option.setAttribute('data-variant-selector', '');
      option.className = 'storecrm-variantselector-option';
      option.textContent = variantLabel(variant);
      applyFavoriteState(option, variant.id);
      option.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!window.storecrm) return;
        window.storecrm.toggleWishlist(option, isVariantFavorited(variant.id), favoriteConfig().is_only_member, favoriteConfig().non_member_link || '');
        removeDropdowns();
      });
      dropdown.appendChild(option);
    });

    document.body.appendChild(dropdown);
  }

  function ensureStorecrmRender() {
    if (!window.storecrm || !document.querySelector(FAVORITE)) return;
    try {
      window.storecrm.render(true);
    } catch (error) {
      // StoreCRMが初期化途中の場合は次のスケジュールに任せる
    }
  }

  function scheduleRender(delay) {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(ensureStorecrmRender, delay || 100);
  }

  function scheduleRenderPasses() {
    scheduleRender(100);
    schedulePositionFavorites(150);
    window.setTimeout(observeFavoriteSizing, 200);
    window.setTimeout(ensureStorecrmRender, 500);
    window.setTimeout(positionFavorites, 550);
    window.setTimeout(ensureStorecrmRender, 1500);
    window.setTimeout(positionFavorites, 1550);
  }

  document.addEventListener('click', function (event) {
    var node = closestElement(event.target);
    if (!node) return;

    // ピッカー内のクリック（バリエーション選択）はそのまま処理させる
    if (node.closest(DROPDOWN)) return;

    // クリックされたのが商品カードのお気に入りボタンか
    var fav = node.closest(FAVORITE);
    if (!fav) return;

    var open = document.querySelector(DROPDOWN);
    var btn = node.closest('button, a') || fav.querySelector('button') || fav;

    if (!isMultiVariantFavorite(fav)) return;

    consumeClick(event);

    if (!isVisibleDropdown(open)) {
      buildFallbackDropdown(fav, btn);
      return;
    }

    var clickedId = fav.getAttribute('data-product-id') || productIdOf(fav);
    var openId = productIdOf(open);
    if (openId && clickedId && openId === clickedId) {
      removeDropdowns();
      return;
    }

    buildFallbackDropdown(fav, btn);
  }, true);

  document.addEventListener('click', function (event) {
    var node = closestElement(event.target);
    if (!node || node.closest(DROPDOWN) || node.closest(FAVORITE)) return;
    removeDropdowns();
  });

  document.addEventListener('DOMContentLoaded', scheduleRenderPasses);
  document.addEventListener('lazyloaded', function () {
    schedulePositionFavorites(50);
  });
  window.addEventListener('load', scheduleRenderPasses);
  window.addEventListener('resize', function () {
    schedulePositionFavorites(100);
  });
  window.addEventListener('pageshow', scheduleRenderPasses);
  document.addEventListener('shopify:section:load', scheduleRenderPasses);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      var shouldRender = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches(FAVORITE)) ||
            (node.querySelector && node.querySelector(FAVORITE))
          );
        });
      });
      if (shouldRender) {
        scheduleRender(100);
        schedulePositionFavorites(150);
        window.setTimeout(observeFavoriteSizing, 200);
      }
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }
})();
